import classNames from 'classnames';
import { ReactComponent as RightArrowIcon } from '../../../images/sprint6/rightIcon.svg';
import AppAvatar from '../app-avatar/AppAvatar';
import IconWrapper from '../wrapper/IconWrapper';
import classes from './TextIconNavTile.module.scss';
import { CircularProgress } from '@material-ui/core';
import Skeleton from 'react-loading-skeleton';

export const TextIconNavTileSkeleton = () => {
    return (
        <div className={classes.actionTile}>
            <div className={classes.actionTile__icon}>
                <Skeleton
                    width="var(--skeleton-icon-size, 48px)"
                    height="var(--skeleton-icon-size, 48px)"
                    circle
                />
            </div>
            <div className={classes.actionTile__content}>
                <Skeleton width={250} height={19} borderRadius={6} />
                <Skeleton width={280} height={20} borderRadius={6} />
            </div>
            <div className={classes.actionTile__arrow}>
                <Skeleton width={22} height={22} borderRadius={8} />
            </div>
        </div>
    );
};

function TextIconNavTile({
    onClick,
    icon,
    title,
    subtitle,
    statusIcon,
    useAvatar,
    avatarProps,
    grayTitle,
    disabled,
    className,
    isLoading,
}) {
    return (
        <div
            className={classNames(
                classes.actionTile,
                disabled && classes.actionTileDisabled,
                className
            )}
            onClick={(e) => {
                if (!disabled) onClick(e);
            }}
        >
            <div className={classes.actionTile__icon}>
                {useAvatar ? <AppAvatar {...avatarProps} /> : <IconWrapper>{icon}</IconWrapper>}
                {statusIcon && <div className={classes.actionTile__status}>{statusIcon}</div>}
            </div>
            <div className={classes.actionTile__content}>
                <h4
                    className={classNames(
                        classes.actionTile__title,
                        grayTitle && classes.grayTitle
                    )}
                >
                    {title}
                </h4>
                {subtitle && <p className={classes.actionTile__subtitle}>{subtitle}</p>}
            </div>
            <div className={classes.actionTile__arrow}>
                {isLoading ? <CircularProgress size={20} color="inherit" /> : <RightArrowIcon />}
            </div>
        </div>
    );
}
export default TextIconNavTile;
